// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3clvC","additionalInfo":"AgreementModal_additionalInfo__1uLR-"};